import { render } from "./gameInfo.vue?vue&type=template&id=2cdbfa30&scoped=true"
import script from "./gameInfo.vue?vue&type=script&lang=js"
export * from "./gameInfo.vue?vue&type=script&lang=js"

import "./gameInfo.vue?vue&type=style&index=0&id=2cdbfa30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdbfa30"]])

export default __exports__